import React, { useState } from 'react'
import { firestore } from '../../firebase';

function SingleRente({rente}) {


    const [bank, setBank] = useState(rente.bank);
    const [renteProsent, setRenteProsent] = useState(rente.rente);
    const [renteType, setRenteType] = useState(rente.rente_type);

    const [show, setShow] = useState(false);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    async function editHandler(e) {
        e.preventDefault();
        try {
            const renteRef = firestore.collection("renter").doc(rente.id);
            const data = {
                bank,
                rente: +renteProsent,
                rente_type: renteType
            }
            renteRef.update(data);
            setMessage("Oppdatert")
        } catch (error) {
            setError("Kunne ikke oppdatere");
        }
    }

    return (
        <div className="mb-1">
            <div onClick={toggle} className="card card-header">
                <div>
                    {rente.bank} - {rente.rente_type} <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span>
                </div>
            </div>
            {show &&(
                <form onSubmit={editHandler} className="my-2">
                    <label>Bank</label>
                    <input className="form-control mb-2" value={bank} onChange={e => setBank(e.target.value)} />

                    <label>Rente Type</label>
                    <input className="form-control mb-2" value={renteType} onChange={e => setRenteType(e.target.value)} />

                    <label>Rente {renteProsent} %</label>
                    <input type="range" className="form-control mb-2" value={renteProsent} onChange={e => setRenteProsent(e.target.value)} max="20" step="0.01" />

                    {error && <div className="alert alert-danger">{error}</div>}
                    {message && <div className="alert alert-success">{message}</div>}
                    <button className="btn btn-block btn-success">Lagre endringer </button>
                </form>
            )}


        </div>
    )


}
export default SingleRente;